import {Component} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {HttpDownloadService} from "../http/http-download.service";
import {Observable} from "rxjs";
import {handleErrors} from "../misc/handle-errors.decorator";

export interface WorkflowTrackingReportModel {
  startDate: string;
  startDatePicker?: string;
  endDate: string;
  endDatePicker?: string;
}

@Component({
  templateUrl: "./dialog-workflow-tracking-report.template.pug",
  providers: [
  ],
})
export class WorkflowTrackingReportComponent
  extends DialogComponent<WorkflowTrackingReportModel, any> {
  public form: FormGroup = new FormGroup({
    startDate: new FormControl(),
    startDatePicker: new FormControl(),
    endDate: new FormControl(),
    endDatePicker: new FormControl(),
  });

  public error: Error;

  static showWorkflowTrackingReportModal(dialogService: DialogService, inputs: WorkflowTrackingReportModel):
  Observable<any> {
    return dialogService.addDialog(WorkflowTrackingReportComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  @handleErrors()
  public loadData(): void {}

  cancel(): void {
    this.result = {success: false};
    this.close();
  }

  @handleErrors()
  public async createReport(): Promise<void> {
    if (this.error) return;

    const form = this.form.getRawValue();

    await this.httpDownloadService.downloadXHR(
      "/api/workflow/export-test-timing",
      {startDate: form.startDate, endDate: form.endDate},
    );

    this.close();
  }

  public checkDates(): void {
    const form = this.form.getRawValue();
    if (form.startDate && form.endDate && (form.startDate > form.endDate)) {
      this.error = new Error("Start date is after end date");
    } else this.error = undefined;
  }

  public DPToTxt(param): void {
    if (param !== "startDate" && param !== "endDate") return;
    const date = this.form.getRawValue()[`${param}Picker`];
    this.form.controls[param].setValue(date);
    this.checkDates();
  }

  public txtToDP(param): void {
    if (param !== "startDate" && param !== "endDate") return;
    let date = this.form.getRawValue()[param];
    if (date && date.trim() === "") {
      date = null; // Allow date to be cleared out, but pass any invalid dates through so that we yell at the user
    }
    this.form.controls[`${param}Picker`].setValue(date);
    this.checkDates();
  }

  ngOnInit(): void {
    this.loadData();
  }

  constructor(
    public dialogService: DialogService,
    public httpDownloadService: HttpDownloadService,
  ) {
    super(dialogService);
  }
}
